import { Injectable } from '@angular/core';
import { MonerisPaySettingsEnvironment } from './shared/interfaces';

@Injectable({
    providedIn: 'root'
})
export class MonerisService {
    getScriptLocation(environment: MonerisPaySettingsEnvironment): string {
        if (environment === MonerisPaySettingsEnvironment.prod) {
            return 'https://gateway.moneris.com/chktv2/js/chkt_v2.00.js';
        } else {
            return 'https://gatewayt.moneris.com/chktv2/js/chkt_v2.00.js';
        }
    }
}
